// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"114b653e","455":"3ebdbd86"}[chunkId] + ".chunk.js";
};